export async function postMessage({
  type,
  payload,
}: {
  type?: string;
  payload: Record<string, unknown>;
}) {
  try {
    // Ensure the service worker is ready and active
    const registration = await navigator.serviceWorker.ready;

    if (registration.active) {
      registration.active.postMessage({
        type,
        payload,
      });
      console.log("Message posted to service worker.");
    } else {
      console.log("No active service worker found.");
    }
    console.log("Post Message");
  } catch (error) {
    console.error("Error posting message to service worker:", error);
    throw error; // Rethrow the error if needed to handle in the outer try...catch block
  }
}
